module.exports = __webpack_public_path__ + "static/media/7.cc0eca99.png";